module.exports = "../study/imgs/maps/Tokyo/GWQ8/Climate/SnowFall/Tokyo_SnowFall_MRI_RCP85_End.png";